import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07318813&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=07318813&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=07318813&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07318813",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07318813')) {
      api.createRecord('07318813', component.options)
    } else {
      api.reload('07318813', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=07318813&scoped=true&", function () {
      api.rerender('07318813', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/configuration/index.vue"
export default component.exports